import { render, staticRenderFns } from "./MenuToggle.vue?vue&type=template&id=37683cb6"
import script from "./MenuToggle.vue?vue&type=script&lang=js"
export * from "./MenuToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports